import React from 'react';
import { Box, Typography } from '@mui/material';
import { PercentageDiffCircle } from './PercentageDiffCircle.component';
import { mapAssessmentScoreToDescription } from '@uplift/utils';
import { useL10n } from '@uplift/hooks';
import { AssessmentKeys } from '@uplift/types';
import { FormActivityItem } from './FormActivityItem.component';
import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';


type AssessmentFormActivityItemContentProps = {
  assessmentKey: AssessmentKeys;
  percentage?: number;
  score: number;
  completedAt?: string;
};


export const AssessmentFormActivityItemContent: React.VFC<AssessmentFormActivityItemContentProps> = (props) => {
  const timezone = useTimezone();
  const l10n = useL10n();
  const mapScoreName = mapAssessmentScoreToDescription(props.assessmentKey, l10n);

  return (
    <Box display="flex" alignItems="center">
      {(typeof props.percentage === 'number') && <PercentageDiffCircle percentage={props.percentage} />}
      <Box ml={0.5}>
        <Typography color="textSecondary">
          <strong>{props.score}</strong> <span style={{ fontWeight: 450 }}>{mapScoreName(props.score)}</span>.
          {props.completedAt && (<>{' '} <Typography component="span">Completed {CalendarDateService.format(props.completedAt, 'M/D/YYYY', 'M/D/YYYY', { timezone })}</Typography></>)}
        </Typography>
      </Box>
    </Box>
  );
};


export type AssessmentFormActivityItemProps = {
  title: string;
  assessmentKey: AssessmentKeys;
  completedAt?: string;
  expiredAt?: string;

  percentage?: number;
  score: number;

  onClick?: () => void;
};


export const AssessmentFormActivityItem: React.FC<AssessmentFormActivityItemProps> = (props) => {
  return (
    <FormActivityItem
      onClick={props.onClick}
      title={props.title}
      completedAt={props.completedAt}
      expiredAt={props.expiredAt}
    >
      {props.completedAt ? (
        <AssessmentFormActivityItemContent
          assessmentKey={props.assessmentKey}
          completedAt={props.completedAt}
          percentage={props.percentage}
          score={props.score}
        />
      ) : null}
    </FormActivityItem>
  );
};
